
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_4yi2u_sykyg_93",
  "outline": "awsui_outline_4yi2u_sykyg_105",
  "toggle-control": "awsui_toggle-control_4yi2u_sykyg_124",
  "toggle-control-checked": "awsui_toggle-control-checked_4yi2u_sykyg_133",
  "toggle-control-disabled": "awsui_toggle-control-disabled_4yi2u_sykyg_136",
  "toggle-handle": "awsui_toggle-handle_4yi2u_sykyg_143",
  "toggle-handle-checked": "awsui_toggle-handle-checked_4yi2u_sykyg_155",
  "toggle-handle-disabled": "awsui_toggle-handle-disabled_4yi2u_sykyg_158"
};
  